/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

jQuery(function($){
  	//-- Enable Use Strict Mode --
  	"use strict";

  	$().ready(function() {
        if(window.location.href == "https://shop.eji.org/collections/all" ) {
        	location.href = "https://shop.eji.org/"
        }
        if(window.location.href == "https://shop.eji.org/collections/" ) {
        	location.href = "https://shop.eji.org/"
        }

        if(window.location.href == "https://eji-store.madeo.is/collections/" ) {
        	location.href = "https://shop.eji.org/"
        }
        if(window.location.href == "https://eji-store.madeo.is/collections/all" ) {
        	location.href = "https://shop.eji.org/"
        }
    
    
        
        var pgwBrowser = $.pgwBrowser(),
            currentOs = pgwBrowser.os.group,
            currentBrowser = pgwBrowser.browser.group,
            currentBrowserVersion = pgwBrowser.browser.majorVersion;
    
        if(currentBrowser == "Explorer" && currentBrowserVersion == "11"){
            $("body").addClass("ie-11");
        } 
        if(currentBrowser == "Firefox"){
            $("body").addClass("ff");
        } 
                
        if($('body').hasClass('template-product')){
        	carouselNormalization();
        }

  		/* detect browser */
  		var OSName="Unknown OS";
		if (navigator.appVersion.indexOf("Win")!=-1) OSName="Windows";
		else if (navigator.appVersion.indexOf("Mac")!=-1) OSName="MacOS";
		else if (navigator.appVersion.indexOf("X11")!=-1) OSName="UNIX";
		else if (navigator.appVersion.indexOf("Linux")!=-1) OSName="Linux";

		console.log('Your OS is: '+OSName);
				$('body').addClass(OSName);

			
			/*if(navigator.userAgent.contains('MSIE'))
			{
			    $('body').addClass('ie');

			}*/
			//DetectBrowser_OS();
			
		dropmenu_collection();		

		/* NAVigation */
  		var direction = 0,
  			$header = $('.shopify-section--header'),
  			//$headerTop = $('.shopify-section--header').offset().top,
  			topLockPoint = 0,
  			ie_thumbnails_stopper;
  			/*if($('body').hasClass('template-product')){
  				if( $("#shopify-section-announcement") ){
	  				//topLockPoint = $("#shopify-section-announcement").outerHeight() + 125;
	  			}
  			} else{*/

  				if( $("#shopify-section-announcement") ){
  					if ($(window).width() >= 992) {
	  					topLockPoint = $("#shopify-section-announcement").outerHeight() + 10;
  					} else{
	  					topLockPoint = $("#shopify-section-announcement").outerHeight();
  					}
	  			}
	  			$(window).resize(function(){
	  				if ($(window).width() >= 992) {
	  					topLockPoint = $("#shopify-section-announcement").outerHeight() + 10;
  					} else{
	  					topLockPoint = $("#shopify-section-announcement").outerHeight();

	  					/*if($(window).scrollTop() > topLockPoint){
							$("body").addClass("mobile-header-fixed");
						}else{
							$("body").removeClass("mobile-header-fixed");
						}*/
  					}
	  			});

	  			//if(){
	  				
	  				Cookies.set('announceBar', 'false', { domain: 'https://eji-store.madeo.is' });
        
		        	$('#Btn_Close').click(function(){
		        		$('#shopify-section-announcement').slideUp();
		        		$('body').addClass('bar-removed');
		        		topLockPoint = 0;

		        		Cookies.set('announceBar', 'true');
		        		//console.log( Cookies.get('announceBar') );
		        	});
		        //}
		        //console.log( Cookies.get('announceBar') );
		        


	  			ie_thumbnails_stopper = $("header").outerHeight() + $(".Product").height() - 200 ; 

  			//}

  			
  			$('.Product__SlideshowNav.Product__SlideshowNav--thumbnails').addClass('natural');


            

  			//console.log('topLockPoint: ', topLockPoint);
        	
			$(window).scroll(function(event){
			   var scroller = $(this).scrollTop();
			   
			   if ($(window).width() >= 992) {
			  		if(scroller > 200 && direction > scroller){
			  			$header.addClass("scroll");
			  			$("body").addClass("scrolling-header-active");
			  		} else if(scroller > 200 && direction < scroller){ 
			  			$header.addClass("scroll-ready");
		  				//$(".wrap_all").css("padding-top", paddingTop);
			  			$header.removeClass("scroll");
			  			$("body").removeClass("scrolling-header-active"); //change it from (addclass to removeclass)
		          		$("body").addClass("scroll-ready-body");
		  			} else if(scroller <= topLockPoint) {
			  			$header.removeClass("scroll");
			  			$header.removeClass("scroll-ready");
			  			//$(".wrap_all").css("padding-top", "0");
			  			$("body").removeClass("scrolling-header-active");
		          		$("body").removeClass("scroll-ready-body");
			  		}

	                if($("body").hasClass("ie-11") && $('body').hasClass('template-product')){
	                    if($(window).width() >= 992){
	                        ie_thumb_scrolling(scroller);
	                    }
	                    if($(window).width() <= 992){
	                        ie_dots_scrolling(scroller); 
	                    }
	                }

			  		direction = scroller;
				}


				
				
				/*if( $(window).width() < 992 ){					
					if(scroller > topLockPoint){
						$("body").addClass("mobile-header-fixed");

					}else{
						$("body").removeClass("mobile-header-fixed");
					}
				}*/
		    });
        
        
                
                function ie_thumb_scrolling(scroller){
                   var $thumbs = $('.Product__SlideshowNav.Product__SlideshowNav--thumbnails'),
                       $holder = $("#main"),
                       $product = $(".Product"),
                       $thumbs_scroll = $(".Product__SlideshowNavScroller"),
                       start_count = $product.offset().top - 78,
                       point_start = $product.offset().top - 78, 
                       point_end = ($product.offset().top + $product.height()) - ($thumbs_scroll.height() + 78);
                    if(scroller >= point_start && scroller < point_end){
                        $thumbs.addClass("fixed").removeClass("bottom").css("left", $(".product-container").offset().left);
                    } else if(scroller >= point_end  ){
                        $thumbs.addClass("bottom").removeClass("fixed").css("left", "0");
                    } else if(scroller < point_start && $thumbs.hasClass("fixed")){
                        $thumbs.removeClass("fixed bottom").css("left", "0");
                    }
                    console.log("thumb ie");
                }
                
                function ie_dots_scrolling(scroller){
                   var $thumbs = $('.Product__SlideshowNav--dots .Product__SlideshowNavScroller'),
                       $holder = $("#main"),
                       $product = $(".Product"),
                       $thumbs_scroll = $(".Product__SlideshowNavScroller"),
                       start_count = $product.offset().top - 78,
                       point_start = $product.offset().top, 
                       point_end = ($product.offset().top + $product.height()) - $(window).height();
                    if(scroller >= point_start && scroller < point_end){
                        $thumbs.addClass("fixed").removeClass("bottom").css("left", ($(".product-container").offset().left - 30));
                    } else if(scroller >= point_end  ){
                        $thumbs.addClass("bottom").removeClass("fixed").css("left", "0");
                    } else if(scroller < point_start && $thumbs.hasClass("fixed")){
                        $thumbs.removeClass("fixed bottom").css("left", "0px");
                    }
                    console.log("Dots ie");
                }


		    /*largeTitle();
	        $(window).resize(function(){ 
	           largeTitle(); 
	        });*/

	        MobileNav();
        
		  /* $('.ProductItem__ColorSwatchList').each(function(){
		  		
		  	if( $(this).find('.ProductItem__ColorSwatchItem').length == 1){

		  		$(this).hide();
		  	}
		  }); */


				  //* pge transtion */
			/*	setTimeout(function(){
                $(".PageTransition_eji").addClass("out");
                    console.log("timedout 500ms");
                }, 500);
                    //$(".switch-holder").removeClass("fade-out");*/
               /* setTimeout(function(){
                    $(".PageTransition_eji").removeClass("page-load out in");  
                }, 750);

		  $(".PageTransition_eji").addClass("out");
	        setTimeout(function(){
	            $(".PageTransition_eji").removeClass("page-load out disabled"); 
	        }, 750); */


	        //pageTransition();
			
  	}); /* // document ready */

  		function MobileNav(){
            var $trigger = $(".menu-icon-wrapper"),
            	$header = $('.Eji_Header'),
            	menu_ = $('#sidebar-menu'),
           	    _body = $('body');
            

            $trigger.on("click", function(){
            	if( _body.hasClass('sharing-menu-open')){
            		
            		_body.addClass("sharing-menu-out");
            		setTimeout(function(){
	                    _body.removeClass("sharing-menu-open");
	                    _body.removeClass("sharing-menu-in");
	                    menu_.attr("aria-hidden", "true");

	                }, 550);         

            	}
            	else{
            		menu_.attr("aria-hidden", "false");
            		_body.removeClass("sharing-menu-out");
            		_body.addClass("sharing-menu-open");
            		setTimeout(function(){
	                    _body.addClass("sharing-menu-in");
	                }, 350); 
            	}
                return false;
            });
                
        }
  		/*function largeTitle(){
            var $title = $(".large-title");

            jQuery($title).each(function() {
            var $numWords = $(this).text().split(" ").length;
            
                if (($numWords > 10)) {
                    $(this).addClass("min");
                } 
                else{
                	$(this).addClass("x-large-title");
                }
            });
                
        }*/


        /*function pageTransition(){
	        var $links = $(".Header__Wrapper a, .ProductItem__Title a, a.ProductItem__ImageWrapper, .CollectionItem__Link").not("[target=_blank], .cart_btn");
	           // $ext_links = $("header nav a[target=_blank]");
	        $links.on("click", function(){
	            var url = $(this).attr("href");
	            $(".PageTransition_eji").addClass("in");
	            setTimeout(function(){
	                window.location = url;
	                //window.location.assign(url);
	            }, 1000);
	            return false;
	        }); */
	        /*$ext_links.on("click", function(){
	            var $target = $(this).attr("href");
	            if($("body").hasClass("ios-os") || $("body").hasClass("android-os")){
	                $(".mobile-nav-trigger").trigger('click');
	                setTimeout(function(){
	                    window.open($target,'_blank');
	                }, 500);
	                return false;
	            }
	        });*/
	  /*  } */



	  function carouselNormalization() {
		var items = $('.Product__Slideshow.Carousel .Carousel__Cell'), //grab all slides
		    heights = [], //create empty array to store height values
		    tallest; //create variable to make note of the tallest slide

		if (items.length) {
		    function normalizeHeights() {
		        items.each(function() { //add heights to array
		            heights.push($(this).height()); 
		        });
		        tallest = Math.max.apply(null, heights); //cache largest value
		        items.each(function() {
		            $('.Product__Slideshow.Carousel .flickity-viewport').css('min-height',tallest + 'px');
		        });
		    };
		    normalizeHeights();

		    $(window).on('resize orientationchange', function () {
		        tallest = 0, heights.length = 0; //reset vars
		        items.each(function() {
		            $('.Product__Slideshow.Carousel .flickity-viewport').css('min-height','0'); //reset min-height
			        }); 
			        normalizeHeights(); //run it again 
			    });
		    }
		}

		function dropmenu_collection(){
			var filter_wrapper = $('.CollectionFilters');
			
			filter_wrapper.each(function(){
				var _this = $(this);
				var selector 	 = _this.find('.filter-trigger'),
					list         = _this.find('.subCategory-list'),
					button_text  = _this.find('.subCategory-list a.active').html();

				selector.html(button_text);
				selector.click(function(){

					if(list.hasClass('opened')){
						list.slideUp().removeClass('opened');
						_this.removeClass('active');

					}
					else{
						list.slideDown().addClass('opened');
						_this.addClass('active');
					}					
				});
				if($('body').hasClass('template-collection')){

				}
				else{
					$('.subCategory-list li a').each(function(){
						$(this).click(function(e){
							e.preventDefault();
							button_text = $(this).html();
							$('.subCategory-list li a').removeClass('active');
							$(this).addClass('active');
							selector.html(button_text);
							list.slideUp().removeClass('opened');
							filter_wrapper.addClass('selected').removeClass('active');

						})
					})
				}

			})
		}
	
    var sizeChart_popup = $("#sizeChart_popup");
		
	$('.size-chart-holder ').click(function(e){
      var $this = $(this);
      //console.log('target', e.target);
      $('body').addClass("chart-popup-open");
      sizeChart_popup.addClass("active");
      $this.addClass("active");
              //}
      if ($(e.target).attr('class') == 'modal_background'){
        	$('body').removeClass("chart-popup-open")
            sizeChart_popup.removeClass("active");
        	$this.removeClass("active");
      }
      if ($(e.target).attr('class') == 'modal_close'){
        	$('body').removeClass("chart-popup-open")
            sizeChart_popup.removeClass("active");
        	$this.removeClass("active");
      }
    });
  	
  $(document).keyup(function(e) {
    if (e.keyCode === 27) {
    	$('body').removeClass("chart-popup-open")
        sizeChart_popup.removeClass("active");
      	$('.size-chart-holder ').removeClass("active");
    }  // esc
  });
  
  

})
 